import useAuth from "../hooks/useAuth";
import "../styles/login.css";
import { Mail, LockOpen } from "@mui/icons-material";
const Login = () => {
  const { login, set_admin_email, set_admin_password } = useAuth();
  return (
    <div className="main-container">
      <div className="login-container">
        <div className="login-sub-container">
          <h1 className="login-heading">Login</h1>
          <div className="input-container">
            <input
              type="text"
              className="input"
              placeholder="Email"
              onChange={(e) => set_admin_email(e.target.value)}
            />
            <Mail color="#026c93" className="input-icon" />
          </div>
          <div className="input-container">
            <input
              type="password"
              className="input"
              placeholder="Password"
              onChange={(e) => set_admin_password(e.target.value)}
            />
            <LockOpen color="#026c93" className="input-icon" />
          </div>
          <button className="login-btn" onClick={login}>Sign in</button>
        </div>
      </div>
    </div>
  );
};

export default Login;
